export default "__VITE_ASSET__DWJYEAXi__"